﻿/** @module manager */

/**
 * Funktionalität für Traces mit dem Tagmanager
 *
 */
export class OpaccTag {
	constructor() {
		this.basketId = document.querySelector('.otm-basketid');
		/*
        this.pushData();
		window.dataLayer.push(function() {
			this.reset();
		  })
        */
		this.pushDataGA4();
	}

	/**
	 *
	 *
	 */
	pushData() {
		let data = null;
		if (this.basketId) {
			data = this.getPurchaseData();
		}
		if (data && window.dataLayer) {
			window.dataLayer.push(data);
		}
	}

	pushDataGA4() {
		let data2 = null;
		if (this.basketId) {
			data2 = this.getPurchaseDataGA4();
		}
		if (data2 && window.dataLayer) {
			window.dataLayer.push(data2);
		}
	}

	/**
	 *
	 *
	 * @returns {*}
	 */
	getPurchaseData() {
		return {
			'event': 'event-purchase',
			'ecommerce': {
				'purchase': {
					'actionField': this.getActionData(),
					'products': this.getProductData()
				}
			}
		};
	}

	/**
	 *
	 *
	 * @returns {*}
	 */
	getActionData() {
		let data = {};
		let affiliation = document.querySelector('.otm-affiliation');
		let revenue = document.querySelector('.otm-revenue');
		let tax = document.querySelector('.otm-tax');
		let shipping = document.querySelector('.otm-shipping');
        let currency = document.querySelector('.otm-currency');
		data['id'] = this.basketId.innerText;
		data['affiliation'] = affiliation ? affiliation.innerText : '';
		data['revenue'] = revenue ? parseFloat(revenue.innerText) : '';
		data['tax'] = tax ? parseFloat(tax.innerText) : '';
		data['shipping'] = shipping ? parseFloat(shipping.innerText) : '';
        data['currency'] = currency ? currency.innerText : '';
		return data;
	}

	/**
	 *
	 *
	 * @returns {*}
	 */
	getProductData() {
        
		let data = [];
		let items = document.querySelectorAll('.otm-item');
		Array.from(items).forEach(item => {
			let id = item.querySelector('.otm-id');
			let name = item.querySelector('.otm-name');
			let brand = item.querySelector('.otm-brand');
			let category = item.querySelector('.otm-category');
			let price = item.querySelector('.otm-price');
			let quantity = item.querySelector('.otm-quantity');
			let position = item.querySelector('.otm-position');
            let currency = item.querySelector('.otm-itemcurrency');
			data.push({
				'id': id ? id.innerText : '',
				'name': name ? name.innerText : '',
				'brand': brand ? brand.innerText : '',
				'category': category ? category.innerText : '',
				'price': price ? parseFloat(price.innerText) : '',
				'quantity': quantity ? parseFloat(quantity.innerText) : '',
				'position': position ? parseFloat(position.innerText) : '',
                'currency': currency ? currency.innerText : ''
			});
		});
		return data;
	}


	/** GA4 Tracking */
	getPurchaseDataGA4() {
		return {
			'event': 'event-purchase-ga4',
			'ecommerce': this.getActionDataGA4()
		};
	}


	getActionDataGA4() {
		let data2 = {};
		let affiliation = document.querySelector('.otm-affiliation');
		let revenue = document.querySelector('.otm-revenue');
		let tax = document.querySelector('.otm-tax');
		let shipping = document.querySelector('.otm-shipping');
        let currency = document.querySelector('.otm-currency');
		data2['transaction_id'] = this.basketId.innerText;
		data2['affiliation'] = affiliation ? affiliation.innerText : '';
		data2['value'] = revenue ? parseFloat(revenue.innerText) : '';
		data2['tax'] = tax ? parseFloat(tax.innerText) : '';
		data2['shipping'] = shipping ? parseFloat(shipping.innerText) : '';
		data2['currency'] = currency ? currency.innerText : '';
		data2['items'] = this.getProductDataGA4();
		return data2;
	}

	getProductDataGA4() {
		let data2 = [];
		let items = document.querySelectorAll('.otm-item');
		Array.from(items).forEach(item => {
			let id = item.querySelector('.otm-id');
			let name = item.querySelector('.otm-name');
			let brand = item.querySelector('.otm-brand');
			let category = item.querySelector('.otm-category');
			let price = item.querySelector('.otm-price');
			let quantity = item.querySelector('.otm-quantity');
			let position = item.querySelector('.otm-position');
            let currency = item.querySelector('.otm-itemcurrency');
			data2.push({
				'item_id': id ? id.innerText : '',
				'item_name': name ? name.innerText : '',
				'item_brand': brand ? brand.innerText : '',
				'item_category': category ? category.innerText : '',
				'price': price ? parseFloat(price.innerText) : '',
				'quantity': quantity ? parseFloat(quantity.innerText) : ''
			});
		});
		return data2;
	}


}